import { Box, Flex, Heading, Text, Link, Divider, Button, Image, useMediaQuery, } from '@chakra-ui/react';
import { useQuery } from 'react-query';
import { getYoutubePlaylist } from '../../../service';
import { responsiveValue } from '../../../assets/style/defaultTheme';
import dayjs from 'dayjs';
import Slider from 'react-slick';
import SlideArrow from '../../../Component/Button/SlideArrow';
import { VideoBanner } from './style';
import { theme } from '../../../assets/style/theme';

const { flexBoxDirection, participationSideBoxWidth, participationContentBoxWidth } = responsiveValue;

type Props = {
  playlistId: string;
};

function ParticipationContentItemVideo({ playlistId }: Props) {

  const { isLoading, error, data } = useQuery('ParticipationContentItemVideo', () => getYoutubePlaylist(`${playlistId}`));

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const workBannerSetting = {
		infinite: true,
		speed: 500,
		slidesToShow: isMobile ? 1 : 2,
		slidesToScroll: 1,
		nextArrow: <SlideArrow color="w" />,
		prevArrow: <SlideArrow color="w" />,
		variableWidth: true,
		variableHeight: true,
	};

  const isEnglish = window.__LANG__ === 'en';

  return (
    <>
    <Divider mt="14" mb="14" color="b.lg" />
    <Flex align="center" justify="space-between" pb="9">
      <Heading size="4xl" color="b.dgr" >
        { isEnglish ? 'Team-Introduction Videos' : '주요영상' }
      </Heading>
      <Link target="_blank" href={`https://www.youtube.com/playlist?list=${playlistId}`}>
        <Button size="lg" colorScheme="dgr">{ isEnglish ? 'View All' : '전체보기' }</Button>
      </Link>
    </Flex>
    {
      !isLoading && !error && data && (
        <VideoBanner>
        <Slider {...workBannerSetting}>
        {
          data.items.map((item: any, index:number) => (
            <div key={index}>
              <Link fontSize="md" target="_blank" href={`https://www.youtube.com/watch?v=${item.snippet.resourceId.videoId}&list=${playlistId}`}>
              <Box w="lg" h="sm" borderRadius="24" mr={isMobile ? 0 : 3} ml="3" className="item">
                <Image src={item?.snippet?.thumbnails?.standard?.url ? item?.snippet?.thumbnails?.standard?.url : item?.snippet?.thumbnails?.high?.url} objectFit="cover" w={isMobile ? '300px' : '512px'} h={isMobile ? 'auto' : "384px"} borderRadius="24" className="item-image" />
                <Box pt="6" >
                    <Text fontSize="xl">{item.snippet.title}</Text>
                    <Text fontSize="sm" color="b.lg" pt="4">
                      {dayjs(item.snippet.publishedAt).format('YYYY.MM.DD')}
                    </Text>
                </Box>
              </Box>
              </Link>
            </div>
          ))
        }
        </Slider>
        </VideoBanner>
      )
  }
  </>
  )
}

ParticipationContentItemVideo.defaultProps = {};

export default ParticipationContentItemVideo;
